import { Outlet } from "react-router-dom";
import Header from "./Header";
import SubNav from "./SubNav";
import AgentSessionBanner from "./agents/AgentSessionBanner";
import useForYouCount from "../hooks/useForYouCount";
import useMe from "../hooks/useMe";
import useWebMcpTools from "../hooks/useWebMcpTools";

function AppShell() {
  // One /users/me/ for the whole shell: the banner needs `kind`, the nav
  // hides the Agents entry for agents, and the /agents routes read it from
  // the outlet context rather than asking again. A failed ask is passed
  // on with a way to ask again, so a page that fails closed while `me` is
  // unknown can say why and offer Retry (investing Settings).
  const { me, loading: meLoading, error: meError, refresh: refreshMe, update: updateMe } = useMe();
  const isAgentSession = me?.kind === "agent";
  // Fail closed: until /users/me/ says human, do not offer Agents / My token.
  // The banner stays off until kind is known, so a human never gets a false
  // "signed in as an agent" bar on first paint.
  const hideAgentsNav = meLoading || me?.kind !== "human";
  // What's for you in Discussions, on the nav (D14) — anyone signed in,
  // agents included.
  const forYou = useForYouCount({ enabled: Boolean(me) });
  // Typed tools for an agent working in this page (projects/webmcp) —
  // only where the browser offers WebMCP, only once we know who you are.
  useWebMcpTools(me);

  return (
    // A page that marks itself data-fill-viewport (the house planner) gets
    // a shell exactly the window's height from lg, so its panes scroll
    // inside rather than growing the page.
    <div className="flex min-h-screen flex-col font-sans lg:has-[[data-fill-viewport]]:h-dvh">
      <Header
        isAgentSession={hideAgentsNav}
        me={me}
        onMeChange={updateMe}
        badges={{ discussions: forYou }}
      />
      <SubNav isAgentSession={hideAgentsNav} />
      {isAgentSession && <AgentSessionBanner me={me} />}
      {/* Pages provide their own container; the shell only owns vertical
          layout. */}
      <main className="flex min-h-0 flex-1 flex-col">
        <Outlet context={{ me, meLoading, meError, refreshMe, forYouCount: forYou }} />
      </main>
    </div>
  );
}

export default AppShell;
